export const LoadingIndicator = () => {
    return (
        <div className="dark-bg full-cnt">
            <img
                src="/svgs/loader.svg"
                alt=""
                className="loader-img"
                width={50}
                height={50}
            />
        </div>
    )
}